import styled from 'styled-components';

// Helpers
import { angleDown } from '~/App/helpers/icons';
import mq from '~/App/helpers/mq';

type ButtonProps = {
  isExpanded: boolean;
};

export const Button = styled.button<ButtonProps>`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  width: 100%;

  &::after {
    ${angleDown};
    font-size: 1.75rem;
    line-height: 1;
    display: block;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.themeColors.primary};
    text-align: center;
    position: absolute;
    right: 0;
    top: calc(50% - 0.875rem);
    color: ${({ theme }) => theme.colors.white};
    transition: transform 0.3s ease;
    transform: ${({ isExpanded = true }) =>
      isExpanded ? 'none' : 'rotate(-180deg)'};

    ${({ isExpanded = true }) => mq('≥large')`
      transform: ${isExpanded ? 'rotate(-180deg)' : 'none'};
    `};
  }

  &:hover,
  &:focus {
    &::after {
      background-color: ${({ theme }) => theme.themeColors.primaryHover};
    }
  }
`;
